import { useEffect } from "react";
import Router from "./routes/router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import CreatePostPopup from "./components/posts/CreatePostPopup";
import { useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import Portal from "./utils/Portal";
import ErrorBoundary from "./components/ErrorBoundary";
import { useBranding } from "./hooks/useBranding";

export const queryClient = new QueryClient();

function BrandingLoader() {
  useBranding();
  return null;
}

function App() {
  const user = useSelector((state) => ({ ...state.user.userinfo }));
  const createPost = useSelector((state) => state.createPost);

  useEffect(() => {
    if (createPost.isOpen) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
    }
  }, [createPost.isOpen]);

  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <BrandingLoader />
        {createPost.isOpen && <CreatePostPopup user={user} />}
        <Portal>
          <Toaster position="bottom-left" reverseOrder={false} />
        </Portal>
        <Router />
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
